export enum LandingOptionsMethodsEnumeration {
  ACCOUNT_CHECK = 'ACCOUNT_CHECK',
  BIZUM = 'BIZUM',
  OPENBANKING = 'OPENBANKING',
  TGSS = 'TGSS',
  VIDEOCALL = 'VIDEOCALL',
}
